export default __webpack_public_path__ + "static/media/newIcon.6c5fc742.svg";